import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Monitor, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

const LOGIN_BG = "/foto-scuola.jpg";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={LOGIN_BG} alt="Edificio scolastico" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0,47,167,0.72)", mixBlendMode: "multiply" }} />
        <div className="relative z-10 flex h-full flex-col justify-between p-12 text-white">
          <span className="font-mono text-sm tracking-widest uppercase opacity-90">Gestione Sostituzioni</span>
          <div>
            <h1 className="font-heading text-5xl font-black leading-tight tracking-tight">
              I.T.E.<br />"Alfonso Gallo"
            </h1>
            <p className="mt-4 max-w-sm text-lg text-white/80">
              Comunicazione in tempo reale delle sostituzioni ai docenti disponibili.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm">
          <div className="mb-10">
            <h2 className="font-heading text-3xl font-bold tracking-tight">Accesso Amministratore</h2>
            <p className="mt-2 text-muted-foreground">Inserisci le tue credenziali per gestire le sostituzioni.</p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@scuola.it"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <Button type="submit" data-testid="login-submit-button" disabled={loading} className="w-full h-11 rounded-md">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <LogIn className="mr-2 h-4 w-4" />}
              Accedi
            </Button>
          </form>
          <Link
            to="/tv"
            data-testid="go-to-tv-link"
            className="mt-8 flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            <Monitor className="h-4 w-4" /> Apri schermata TV pubblica
          </Link>
        </div>
      </div>
    </div>
  );
}
